module.exports = __webpack_public_path__ + "static/media/scg-icon.2756c78f.woff";